import { render } from "./ImageAnsweringView.vue?vue&type=template&id=19930be0&scoped=true"
import script from "./ImageAnsweringView.vue?vue&type=script&lang=js"
export * from "./ImageAnsweringView.vue?vue&type=script&lang=js"

import "./ImageAnsweringView.vue?vue&type=style&index=0&id=19930be0&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19930be0"]])

export default __exports__